<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Fleet Managers</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Fleet Managers
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4>Fleet Managers</h4>
                </div>

                <div class="card-body">
                    <div class="mb-2">
                        <form @submit.prevent="paginatedData">
                            <div class="d-flex justify-content-center mt-2 mb-2">
                                <div class="col-xl-4 col-md-6">
                                    <label>Search</label><br/>
                                    <input type="text" v-model="searchTerm"
                                           class="form-control"
                                           placeholder="🔎 Search this table (Name, email, phone)"
                                           @keyup="paginatedData"
                                    >
                                </div>
                                <div class="col-xl-4 col-md-6">
                                    <label>Verification Status</label><br/>
                                    <select class="form-control" v-model="filter.verification_status">
                                        <option value="">All</option>
                                        <option value="verified">Verified</option>
                                        <option value="unverified">Unverified</option>
                                    </select>
                                </div>

                                <div class="col-xl-4 col-md-6">
                                    <label>&nbsp;</label><br/>
                                    <button type="submit" class="btn btn-primary">Filter</button>
                                    <button type="button" class="btn btn-default" @click="resetFilter">Reset</button>
                                </div>
                            </div>
                        </form>
                    </div>

                    <vue-good-table
                        class="dataTable"
                        mode="remote"
                        :isLoading.sync="tableDataLoading"
                        :totalRows="totalRecords"
                        :pagination-options="paginationOptions"
                        @on-page-change="onPageChange"
                        @on-per-page-change="onPerPageChange"
                        @on-sort-change="onSortChange"
                        styleClass="vgt-table"
                        :columns="columns"
                        :rows="allFleetManagers"
                    >

                        <div slot="emptystate" class="loading-container">
                            <img src="/images/Spinner.svg" alt="">
                        </div>
                        <template slot="table-row" slot-scope="props">
                             <span v-if="props.column.field === 'sn'">
                                    {{ serialNo(props) }}
                             </span>
                            <span v-else-if="props.column.field === 'email'">
                                <a :href="`mailto:${props.row.email}`">{{ props.row.email }}</a>
                            </span>
                            <span v-else-if="props.column.label === 'Name'">
                                {{ props.row.first_name + ' ' + props.row.last_name }}
                            </span>
                            <span v-else-if="props.column.label === 'Status'">
                                    <b>Verification Status:</b>
                                    <span class="badge"
                                          :class="{ 'badge-primary': props.row.is_verified,  'badge-info': !props.row.is_verified}">{{
                                            props.row.is_verified ? 'Verified' : 'Not verified'
                                        }}</span>
                                    <br>
                                    <b>Account Status:</b>
                                    <span class="badge"
                                          :class="{ 'badge-primary': props.row.is_active, 'badge-danger': !props.row.is_active}">{{
                                            props.row.is_active ? 'Active' : 'Deactivated'
                                        }}</span>
                                </span>
                            <span v-else-if="props.column.field === 'created_at'">
                                {{ formatDateTime(props.row.created_at) }}
                            </span>
                            <span v-else-if="props.column.field === 'action'">
                                <div class="btn-group mr-1 mb-1">
                                    <button type="button" class="btn btn-outline-info dropdown-toggle btn-sm"
                                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fa fa-info"></i>
                                    </button>
                                     <div class="dropdown-menu" x-placement="bottom-start"
                                          style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(0px, 21px, 0px);">
                                        <a class="dropdown-item text-secondary"
                                           :href="route('admin.fleet_managers.show', props.row.id)">
                                            <i class="feather icon-eye"></i> View User Details
                                        </a>
                                        <a class="dropdown-item text-secondary"
                                            :href="route('admin.fleet_managers.documents', props.row.id)">
                                            <i class="feather icon-eye"></i> View Uploaded Documents
                                        </a>
                                        <a href="#"
                                           @click.prevent="updateFleetManager(props.row.id, props.row.is_active, 'is_active')"
                                           class="dropdown-item">
                                            <i class="feather icon-check"></i>
                                            {{ !props.row.is_active ? 'Activate ' : 'Deactivate ' }} Account
                                        </a>
                                        <a v-if="!props.row.is_verified" href="#"
                                           @click.prevent="updateFleetManager(props.row.id, props.row.is_verified, 'is_verified')"
                                           class="dropdown-item">
                                            <i class="feather icon-check"></i>
                                            {{ !props.row.is_verified ? 'Verify ' : 'Refute' }} Account
                                        </a>
                                         <a href="#" @click.prevent="showAlert(props.row.id)" class="dropdown-item text-danger delete"><i
                                             class="feather icon-trash-2"></i> Delete</a>
                                    </div>
                                </div>
                            </span>
                        </template>
                    </vue-good-table>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';

export default {
    metaInfo: {title: 'FleetManager'},
    props: ['fleet_managers'],
    name: "FleetManagerIndex",
    layout: Layout,

    data: () => ({
        filter: {
            status: '',
            verification_status: ''
        },
        isLoadingFilter: false,
        allFleetManagers: [],
        searchFleetManager:{},
        totalRecords: 0,
        serverParams: {
            page: 1,
            perPage: 10
        },
        paginationOptions: {
            enabled: true,
            mode: 'pages',
            perPage: 10,
            perPageDropdown: [5, 10, 20, 50, 100, 200],
            dropdownAllowAll: false,
        },
        columns: [
            {label: 'S/N', field: 'sn'},
            {label: 'Name', field: 'name'},
            {label: 'Email', field: 'email'},
            {label: 'Phone', field: 'phone_number'},
            {label: 'Date Joined', field: 'created_at'},
            {label: 'Status', field: 'status'},
            {label: 'Action', field: 'action', sortable: false},
        ],
        tableDataLoading: false,
        searchTerm: '',
    }),
    created() {
        this.allFleetManagers = this.fleet_managers.data
        this.totalRecords = this.fleet_managers.total
    },
    methods: {
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        },
        onPageChange(params) {
            this.updateParams({page: params.currentPage});
            this.paginatedData();
        },
        onPerPageChange(params) {
            this.updateParams({perPage: params.currentPerPage});
            this.paginatedData();
        },
        onSortChange(params) {
            this.serverParams.sort = {
                type: params[0].type,
                field: params[0].field,
            }
            this.paginatedData();
        },
        async paginatedData() {
            try {
                let url = route('admin.fleet_managers.index') +
                    `?q=${this.searchTerm}&page=${this.serverParams.page}&perPage=${this.serverParams.perPage}&perPage=${this.serverParams.perPage}&verification_status=${this.filter.verification_status}`;
                let {data: {data: {fleet_managers}}} = await axios.get(url);

                this.totalRecords = fleet_managers.total;
                this.paginationOptions.perPage = fleet_managers.per_page;
                this.allFleetManagers = fleet_managers.data
            } catch (e) {
                console.log(e);
            }
        },

        async resetFilter() {
            this.filter = {}
            this.searchTerm = ""

            this.paginatedData();
        },

        updateFleetManager(fleetManagerId, currentStatus, type) {
            try {
                this.$inertia.put(route('admin.fleet_managers.update', fleetManagerId), {
                    [type]: !currentStatus
                }, {
                    preserveScroll: true,
                    onSuccess: () => {
                        const fleetManagerIndex = this.allFleetManagers.findIndex(a => fleetManagerId === a.id);
                        this.allFleetManagers[fleetManagerIndex].is_verified = this.allFleetManagers[fleetManagerIndex].is_verified === 1 ? 0 : 1;
                        this.allFleetManagers[fleetManagerIndex].is_active = this.allFleetManagers[fleetManagerIndex].is_active === 1 ? 0 : 1;
                    },
                });
            } catch (e) {
                console.log(e);
                this.saving = false
            }
        },
        deleteAccount(accountId) {
            try {
                let routeName = 'admin.fleet_managers.destroy';

                this.$inertia.post(route(routeName, accountId), {
                    '_method' : 'delete'
                }, {
                    preserveScroll: true,
                    onSuccess: (response) => {
                        if (! response.props.flash.error) {
                            this.paginatedData();
                        }
                    },
                });
            } catch (e) {
                console.log(e);
                this.saving = false
            }
        },

        showAlert(accountId) {
            let vInstance = this;

            this.$swal.fire({
                title: "Are you sure you want to delete this Fleet manager?",
                text: "You won't be able to revert this!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, delete it!",
                confirmButtonClass: "btn btn-primary mr-3",
                cancelButtonClass: "btn btn-danger ml-1",
                buttonsStyling: false
            }).then(function (result) {
                if (result.value) {
                    vInstance.deleteAccount(accountId)
                }
            });
        },

        serialNo(props) {
            return this.serverParams.page === 1 ? props.index + 1 : (this.serverParams.perPage *
                    (this.serverParams.page - 1)) +
                props.index + 1
        },

        formatDateTime(value) {
            if (! value) return value

            const date = new Date(value);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');

            return `${year}-${month}-${day} ${hours}:${minutes}`;
        },
    }
}
</script>
